import { useParams } from 'react-router'

export const useLinkId = (): string => {
  const { id } = useParams()

  return id || ''
}
